import type { Translations } from './en';

export const it: Translations = {
  nav: {
    services: 'Servizi',
    portfolio: 'Portfolio',
    starModel: 'Modello Stella',
    partners: 'Partner',
    about: 'Chi Siamo',
    contact: 'Contatti',
    getStarted: 'Inizia',
    closeMenu: 'Chiudi menu',
    openMenu: 'Apri menu',
  },
  hero: {
    title: "Costruire l'Eccellenza Aziendale di Domani",
    subtitle: "Impresstars orchestra operazioni aziendali ad alte prestazioni attraverso il nostro innovativo sistema Star Model. Dall'incorporazione alla strategia di crescita, siamo il tuo partner per l'eccellenza operativa.",
    exploreServices: 'Esplora i Servizi',
    learnMore: 'Scopri di Piu',
  },
  services: {
    eyebrow: 'Cosa facciamo',
    title: 'I Nostri Servizi',
    incorporation: {
      title: 'Servizi di Incorporazione',
      description: 'Avvia la tua attivita nel modo giusto con il nostro processo di incorporazione semplificato. Costituzione di LLC, Corp o non-profit in modo semplice.',
    },
    aiSolutions: {
      title: 'Soluzioni IA',
      description: 'Servizi di integrazione IA personalizzati inclusi modelli di machine learning, elaborazione del linguaggio naturale e sistemi decisionali automatizzati.',
    },
    b2bSolutions: {
      title: 'Soluzioni B2B',
      description: 'Servizi B2B completi inclusi sviluppo di partnership, ottimizzazione della catena di fornitura e outsourcing di processi aziendali.',
    },
    marketingStrategy: {
      title: 'Strategia di Marketing',
      description: 'Strategie di marketing basate sui dati su misura per i tuoi obiettivi aziendali, inclusi analisi di mercato e pianificazione della crescita.',
    },
    businessSoftware: {
      title: 'Software Aziendale',
      description: 'Identifica e implementa le soluzioni software giuste per semplificare le tue operazioni e aumentare la produttivita.',
    },
    brandDesign: {
      title: 'Design del Marchio',
      description: 'Progettazione professionale di loghi, sviluppo di identita di marca e materiali di marketing che lasciano un\'impressione duratura.',
    },
    businessConsulting: {
      title: 'Consulenza Aziendale',
      description: 'Guida strategica per ottimizzare le tue operazioni e accelerare la crescita attraverso metodologie collaudate.',
    },
    ctaTitle: 'Pronto a Trasformare la Tua Attivita?',
    ctaText: 'Parliamo di come i nostri servizi possono aiutarti a raggiungere i tuoi obiettivi.',
    ctaButton: 'Inizia',
  },
  starModel: {
    eyebrow: 'Connessi per design',
    title: 'Modelli Stella',
    description: 'Scopri il nostro ecosistema di unita aziendali specializzate e la metodologia operativa alla base.',
    learnHow: 'Come Funziona il Modello Stella',
    captionLeft: 'Operazioni connesse',
    captionRight: 'Slancio condiviso',
    cleaningEdge: {
      title: 'Cleaning EDGE',
      status: 'Attivo',
      description: 'Servizi di pulizia professionale reinventati attraverso la tecnologia e standard di servizio eccezionali.',
      details: 'Cleaning EDGE e un\'azienda di pulizia professionale focalizzata su servizi residenziali e commerciali affidabili, inclusi pulizia post-costruzione e detailing automobilistico, con flussi di lavoro digitali che rendono piu facile la prenotazione, la comunicazione e il follow-up del servizio.',
    },
    ozean: {
      title: 'Ozean',
      status: 'Sviluppo',
      description: 'Una piattaforma di audio stock che offre risorse sonore per creatori, editor, brand e narratori.',
      details: 'Ozean e focalizzato su audio stock curato, aiutando i team creativi a trovare tracce ed elementi sonori per la produzione di contenuti.',
    },
    visitWebsite: 'Visita Sito Web',
  },
  testimonials: {
    eyebrow: 'Storie dei clienti',
    title: 'Testimonianze dei Clienti',
    description: 'Non prendere solo la nostra parola — ascolta cosa hanno da dire i nostri clienti sul lavorare con Impresstars.',
    j94Designs: 'Impresstars ci ha supportato con consulenza HR e ci ha anche aiutato a costruire parti chiave del nostro sito Wix.',
    craftPapi: 'Impresstars ha sviluppato un piano di marketing pratico per il nostro team, rendendo le nostre campagne e priorita molto piu chiare.',
    pawStuffs: 'Impresstars continua a supportare il nostro sito Shopify e fornisce supporto continuo man mano che il nostro negozio cresce.',
  },
  portfolio: {
    eyebrow: 'Lavori selezionati',
    title: 'Il Nostro Portfolio',
    description: 'Esplora i nostri progetti recenti e storie di successo in varie industrie e servizi.',
    filterAll: 'Tutti',
    filterWebsites: 'Siti Web',
    filterApps: 'App e Strumenti',
    filterGames: 'Giochi',
    filterConsulting: 'Consulenza',
    production: 'Produzione',
    showcase: 'Vetrina',
    viewCaseStudy: 'Vedi Case Study',
    visitSite: 'Visita Sito',
    openProject: 'Apri Progetto',
    viewServices: 'Vedi i Nostri Servizi',
    startProject: 'Avvia un Progetto',
    filterAllProjects: 'Tutti i Progetti',
    filterRealWorld: 'Produzione',
    filterShowcase: 'Vetrina',
    sortFeatured: 'In Evidenza',
    sortAZ: 'Titolo: A-Z',
    sortZA: 'Titolo: Z-A',
    sortLabel: 'Ordina per:',
    reset: 'Reimposta',
    showing: 'Mostra',
    of: 'di',
    projects: 'progetti',
    noProjects: 'Nessun progetto trovato per questo filtro per ora.',
    visitProjectWebsite: 'Visita il sito web del progetto',
    catBrandWebsite: 'Sito Web di Marchio',
    catWebDevelopment: 'Sviluppo Web',
    catEcommerceWebsite: 'Sito Web E-commerce',
    catBusinessWebsite: 'Sito Web Aziendale',
    catWebsite: 'Sito Web',
    catJewelleryBrand: 'Marchio di Gioielleria',
    catWebApp: 'App Web',
    catInteractiveApp: 'App Interattiva',
    catUtilityTool: 'Strumento Utilita',
    cat3DWebSandbox: 'Sandbox Web 3D',
    catWebGame: 'Gioco Web',
    catGameExperience: 'Esperienza di Gioco',
    catConsultingMarketingPlan: 'Consulenza e Piano Marketing',
    desc: {
      snouts: "Lavoro web a supporto della presenza online del marchio Snouts.",
      innovaPro: 'Consegna del sito web per Innova Pro focalizzata su una presentazione chiara dei servizi e solide prestazioni.',
      pawstuffs: 'Presenza web e-commerce e supporto del negozio per Pawstuffs.',
      cleaningEdge: 'Lavoro sul sito web e presenza digitale per Cleaning EDGE.',
      cheesePanic: 'Il gatto insegue il topo, il topo vuole il formaggio. Un piccolo gioco web caotico.',
      cleaningEdgeApp: 'Piattaforma self-service focalizzata sulle operazioni per clienti e lavoratori di Cleaning EDGE. Prova la demo di sviluppo con la password cleaningEDGE, e assicurati di selezionare Legacy Mode.',
      angoloDiamonds: 'Lavoro di sviluppo web per Angolo Diamonds.',
      craftPapiGrowth: 'Sviluppo di piano di consulenza e marketing per Craft Papi per rafforzare il posizionamento e l\'esecuzione della crescita.',
      roboticVoiceClicker: 'Esperienza clicker attivata dalla voce con interazione giocosa del pulsante-lucertola.',
      cheatCounter: 'Jorge ha guardato di nuovo la carta in cima al suo mazzo. Qualcuno doveva tenere il conto.',
      klondikeSolitaire: 'Presentazione e interazione di un gioco web ispirato al solitario classico.',
      universeAdventure: 'Concept di avventura spaziale con viaggi galattici ed esplorazione basata su astronavi.',
      interiorDesign3d: 'Una sandbox browser Three.js per importare modelli 3D e costruire scene di interni.',
      pavillionJewellery: 'Presentazione di sito web orientata al marchio per Pavillion Jewellery.',
      hauntedGalleria: 'Un sito vetrina immersivo a tema scuro per un esperienza di galleria infestata con visivi atmosferici e animazioni inquietanti.',
    },
  },
  partners: {
    eyebrow: 'Tecnologia Affidabile',
    title: 'Strumenti che Usiamo e Consigliamo',
    description: 'Queste sono piattaforme con cui lavoriamo attivamente e che consigliamo ai nostri clienti. Se ti iscrivi tramite i nostri link, potremmo guadagnare una referral — senza costi aggiuntivi per te.',
    teaserEyebrow: 'Tecnologia Affidabile',
    teaserTitle: 'Strumenti che Consigliamo',
    seeAllPartners: 'Vedi Tutti i Partner',
    getStarted: 'Inizia',
    ctaTitle: 'Hai Bisogno di Aiuto per Scegliere lo Stack Giusto?',
    ctaText: 'Valutiamo, implementiamo e integriamo strumenti nel tuo flusso di lavoro. Lascia che gestiamo noi la tecnologia cosi tu puoi concentrarti sulla tua attivita.',
    ctaButton: 'Parla con Noi',
    disclaimer: 'Alcuni link in questa pagina sono link di referral. Impresstars puo guadagnare una commissione se ti iscrivi — senza costi aggiuntivi per te.',
    catProductivity: 'Produttivita',
    catAIVoice: 'IA e Voce',
    catBusinessPhone: 'Telefono Aziendale',
    catAIWebBuilder: 'Costruttore Web IA',
  },
  about: {
    eyebrow: 'Il nostro scopo',
    title: 'Chi Sono Impresstars',
    p1: 'In Impresstars, crediamo nella trasformazione delle operazioni aziendali attraverso l\'innovazione e l\'eccellenza. La nostra missione e aiutare le aziende a raggiungere il loro pieno potenziale implementando soluzioni all\'avanguardia e metodologie collaudate.',
    p2: "Fondata sui principi di eccellenza operativa e crescita sostenibile, abbiamo sviluppato il nostro unico sistema Star Model che ha aiutato numerose attivita a raggiungere un successo notevole.",
  },
  clients: {
    title: 'I Nostri Clienti',
    description: 'Siamo orgogliosi di lavorare con queste organizzazioni e di aiutarle a crescere attraverso i nostri servizi e il supporto dedicato.',
  },
  techPlatforms: {
    title: 'Tecnologie e Piattaforme che Supportiamo',
    description: 'Possiamo aiutare con implementazione, ottimizzazione o supporto su questi strumenti e piattaforme.',
    catEcommerce: 'E-commerce e Siti Web',
    catAI: 'IA e Automazione',
    catMarketing: 'Marketing e Crescita',
    catCloud: 'Cloud e Infrastruttura',
    catCreative: 'Produzione Creativa e di Marchio',
    focusEcommerce: 'Competenza principale: lancio e supporto di negozi e siti web orientati alla conversione.',
    focusAI: 'Competenza principale: adozione pratica dell\'IA e automazione dei flussi di lavoro per team in crescita.',
    focusMarketing: 'Competenza principale: monitoraggio delle prestazioni, esecuzione di campagne e SEO fondamentale.',
    focusCloud: 'Competenza principale: distribuzione affidabile e supporto ambienti per operazioni web moderne.',
    focusCreative: 'Competenza principale: asset di esecuzione del marchio che supportano il marketing e la narrazione del prodotto.',
  },
  contact: {
    title: 'Mettiti in Contatto',
    description: 'Pronto a trasformare la tua attivita? Inviaci un messaggio e ti risponderemo entro 24 ore.',
    name: 'Nome',
    namePlaceholder: 'Il tuo nome',
    email: 'Email',
    emailPlaceholder: 'tu@email.com',
    reason: 'Motivo del Contatto',
    reasonPlaceholder: 'Seleziona un motivo',
    message: 'Messaggio',
    messagePlaceholder: 'Come possiamo aiutarti?',
    sending: 'Invio...',
    send: 'Invia Messaggio',
    successTitle: 'Messaggio Inviato!',
    successText: 'Grazie per averci contattato. Ti risponderemo presto.',
    sendAnother: 'Invia un Altro Messaggio',
    recaptchaError: 'Completa la verifica reCAPTCHA.',
    submitError: 'Invio fallito. Riprova o inviaci un\'email direttamente.',
    reasons: {
      incorporationServices: 'Servizi di Incorporazione',
      aiSolutions: 'Soluzioni IA',
      b2bSolutions: 'Soluzioni B2B',
      marketingStrategy: 'Strategia di Marketing',
      businessSoftware: 'Software Aziendale',
      brandDesign: 'Design del Marchio',
      businessConsulting: 'Consulenza Aziendale',
      websiteDevelopment: 'Sviluppo Web',
      websiteSupport: 'Supporto / Manutenzione Web',
      ecommerceSupport: 'Supporto E-commerce',
      generalQuestion: 'Domanda Generale',
      partnership: 'Opportunita di Partnership',
    },
  },
  footer: {
    tagline: 'Trasformare le operazioni aziendali attraverso l\'innovazione e l\'eccellenza.',
    quickLinks: 'Link Rapidi',
    starModels: 'Modelli Stella',
    legal: 'Legale',
    termsConditions: 'Termini e Condizioni',
    privacyPolicy: 'Informativa sulla Privacy',
    contactTitle: 'Contatti',
    city: 'London, ON',
    country: 'Canada',
    rightsReserved: 'Impresstars. Tutti i diritti riservati.',
    notALawFirm: 'Impresstars non e uno studio legale e non fornisce consulenza legale.',
  },
  notFound: {
    title: 'Pagina Non Trovata',
    metaDescription: "La pagina che stai cercando non esiste o e stata spostata.",
    heading: 'Pagina Non Trovata',
    text: "La pagina che stai cercando non esiste o potrebbe essere stata spostata. Rimettiamoti sulla giusta strada.",
    backHome: 'Torna alla Home',
    contactUs: 'Contattaci',
    portfolio: 'Portfolio',
    services: 'Servizi',
  },
  caseStudy: {
    notFound: 'Case Study Non Trovato',
    returnHome: 'Torna alla Home',
    backToPortfolio: 'Torna al Portfolio',
    client: 'Cliente:',
    challenge: 'La Sfida',
    solution: 'La Nostra Soluzione',
    keyResults: 'Risultati Chiave',
    technologiesUsed: 'Tecnologie Utilizzate',
    visitProject: 'Visita Progetto',
    items: {
      cleaningEdgePlatform: {
        title: 'Piattaforma Cleaning EDGE',
        category: 'Sviluppo Web',
        client: 'Cleaning EDGE',
        description: 'Una piattaforma digitale completa per gestire servizi di pulizia, inclusa pianificazione, gestione dei team e feedback dei clienti.',
        challenge: 'Il cliente aveva bisogno di una soluzione scalabile per gestire le crescenti operazioni di servizio di pulizia, gestire le prenotazioni dei clienti e ottimizzare la pianificazione dei team su piu sedi.',
        solution: 'Abbiamo sviluppato una piattaforma web personalizzata che integra gestione delle prenotazioni, pianificazione dei team e tracciamento in tempo reale. La soluzione include un portale clienti, dashboard admin e un\'interfaccia mobile-friendly per i team di pulizia.',
        results: [
          'Riduzione dei conflitti di pianificazione del 95%',
          'Aumento della soddisfazione del cliente al 98%',
          'Miglioramento dell\'efficienza del team del 40%',
          'Abilitazione dell\'espansione a 3 nuove sedi',
        ],
      },
      aiAnalyticsDashboard: {
        title: 'Dashboard Analitica con IA',
        category: 'Soluzioni IA',
        client: 'TechVision Inc.',
        description: 'Dashboard analitica personalizzata che usa il machine learning per predire tendenze aziendali e ottimizzare le operazioni.',
        challenge: 'Il cliente faticava a dare senso alla sua vasta raccolta di dati e aveva bisogno di insight predittivi per prendere migliori decisioni aziendali.',
        solution: 'Abbiamo implementato un sistema di machine learning che analizza i dati storici, predice le tendenze e fornisce insight actionable attraverso un\'interfaccia dashboard intuitiva.',
        results: [
          'Aumento della precisione delle predizioni dell\'85%',
          'Riduzione del tempo decisionale del 60%',
          'Generazione di 2M$ di risparmi',
          'Miglioramento della gestione dell\'inventario del 45%',
        ],
      },
      globalMarketingCampaign: {
        title: 'Campagna Marketing Globale',
        category: 'Strategia di Marketing',
        client: 'Global Solutions Ltd',
        description: 'Strategia di marketing digitale completa che ha aumentato la presenza sul mercato del cliente in tre continenti.',
        challenge: 'Il cliente aveva bisogno di espandere la propria presenza di mercato a livello globale mantenendo un messaggio di marchio coerente e coinvolgimento in diversi contesti culturali.',
        solution: 'Abbiamo sviluppato una strategia di marketing multicanale con contenuti localizzati, pubblicita mirata e adattamento culturale dei materiali di marketing.',
        results: [
          'Raggiunti piu di 2M di nuovi potenziali clienti',
          'Aumento delle vendite globali del 150%',
          'Miglioramento del riconoscimento del marchio dell\'80%',
          'Generato 300% di ROI sulla spesa marketing',
        ],
      },
      hauntedGalleria: {
        title: 'Haunted Galleria',
        category: 'Web Design e Sviluppo',
        client: 'Haunted Galleria',
        description: 'Un sito vetrina immersivo a tema scuro per un esperienza di galleria infestata — con visual atmosferici, animazioni inquietanti e tipografia audace.',
        challenge: 'Il cliente aveva bisogno di una presenza web che rispecchiasse la natura drammatica e misteriosa del suo concept di galleria infestata.',
        solution: 'Abbiamo creato un sito completamente personalizzato con estetica dark ambientale, effetti parallasse e tipografia ispirata all horror per creare suspense.',
        results: [
          'Identita del marchio distintiva in un mercato di nicchia',
          'UX immersiva che mantiene i visitatori coinvolti piu a lungo',
          'Completamente responsive su tutti i dispositivi',
          'Ottimizzato per tempi di caricamento rapidi nonostante effetti visivi ricchi',
        ],
      },
    },
  },
  servicePages: {
    incorporation: {
      title: 'Servizi di Incorporazione',
      metaDescription: "Inizia il tuo viaggio aziendale con fiducia. I nostri servizi di incorporazione forniscono una base solida per il futuro successo della tua azienda.",
      intro: "Inizia il tuo viaggio aziendale con fiducia. I nostri servizi di incorporazione forniscono una base solida per il futuro successo della tua azienda.",
      disclaimer: 'Avviso: Impresstars non e uno studio legale e non fornisce consulenza legale. Consigliamo di consultare un avvocato qualificato per una guida legale.',
      structureOptions: 'Opzioni di Struttura Aziendale',
      structureItems: [
        'Societa a Responsabilita Limitata (LLC)',
        'Corporation (C-Corp, S-Corp)',
        'Organizzazione Non-Profit',
        'Formazioni di Partnership',
      ],
      included: 'Cosa e Incluso',
      includedItems: [
        'Ricerca Nome Commerciale',
        'Atti di Incorporazione',
        'Registrazione EIN',
        'Accordo Operativo',
      ],
      ctaTitle: 'Pronto a Incorporarti?',
      ctaText: 'Discutiamo della migliore struttura per la tua attivita e mettiamoti sulla strada giusta.',
      ctaButton: 'Pianifica una Consulenza',
    },
    aiSolutions: {
      title: 'Soluzioni IA',
      metaDescription: 'Trasforma la tua attivita con soluzioni di intelligenza artificiale all\'avanguardia su misura per le tue esigenze specifiche.',
      intro: 'Trasforma la tua attivita con soluzioni di intelligenza artificiale all\'avanguardia su misura per le tue esigenze specifiche.',
      servicesTitle: 'Servizi IA',
      servicesItems: [
        'Modelli di Machine Learning',
        'Elaborazione del Linguaggio Naturale',
        'Soluzioni di Computer Vision',
        'Analisi Predittiva',
      ],
      implAreas: 'Aree di Implementazione',
      implItems: [
        'Automazione del Servizio Clienti',
        'Analisi dei Dati e Insight',
        'Ottimizzazione dei Processi',
        'Sistemi di Supporto Decisionale',
      ],
      ctaTitle: 'Pronto a Implementare l\'IA?',
      ctaText: 'Esploriamo come l\'IA puo rivoluzionare le tue operazioni aziendali e guidare la crescita.',
      ctaButton: 'Inizia',
    },
    b2bSolutions: {
      title: 'Soluzioni B2B',
      metaDescription: 'Ottimizza le tue operazioni business-to-business con le nostre soluzioni complete progettate per le imprese moderne.',
      intro: 'Ottimizza le tue operazioni business-to-business con le nostre soluzioni complete progettate per le imprese moderne.',
      coreServices: 'Servizi Principali',
      coreServicesItems: [
        'Ottimizzazione della Catena di Fornitura',
        'Sviluppo di Partnership',
        'Outsourcing di Processi',
        'Pianificazione Strategica',
      ],
      benefits: 'Benefici',
      benefitsItems: [
        'Efficienza Aumentata',
        'Riduzione dei Costi',
        'Espansione di Mercato',
        'Crescita dei Ricavi',
      ],
      ctaTitle: 'Trasforma le Tue Operazioni B2B',
      ctaText: 'Ottimizziamo le tue relazioni e processi commerciali per la massima efficienza.',
      ctaButton: 'Contattaci',
    },
    marketingStrategy: {
      title: 'Strategia di Marketing',
      metaDescription: 'Sviluppa una potente strategia di marketing che guida la crescita e si collega con il tuo pubblico target.',
      intro: 'Sviluppa una potente strategia di marketing che guida la crescita e si collega con il tuo pubblico target.',
      strategyComponents: 'Componenti della Strategia',
      strategyItems: [
        'Analisi di Mercato',
        'Ricerca sui Concorrenti',
        'Profilazione del Pubblico Target',
        'Strategia dei Canali',
      ],
      deliverables: 'Deliverable',
      deliverablesItems: [
        'Piano di Marketing',
        'Strategia di Contenuti',
        'Roadmap delle Campagne',
        'Proiezioni di ROI',
      ],
      ctaTitle: 'Pronto a Crescere?',
      ctaText: 'Creiamo una strategia di marketing che porta la tua attivita al livello successivo.',
      ctaButton: 'Inizia a Pianificare',
    },
    brandDesign: {
      title: 'Design del Marchio',
      metaDescription: 'Crea un\'identita di marchio memorabile che risuona con il tuo pubblico e si distingue sul mercato.',
      intro: 'Crea un\'identita di marchio memorabile che risuona con il tuo pubblico e si distingue sul mercato.',
      designServices: 'Servizi di Design',
      designItems: [
        'Design del Logo',
        'Linee Guida del Marchio',
        'Identita Visiva',
        'Materiali di Marketing',
      ],
      deliverables: 'Deliverable',
      deliverablesItems: [
        'Guida Stile del Marchio',
        'Pacchetto Logo',
        'Tavolozza dei Colori',
        'Sistema Tipografico',
      ],
      ctaTitle: 'Pronto per un Nuovo Look?',
      ctaText: 'Creiamo un\'identita di marchio che cattura la tua visione e si collega con il tuo pubblico.',
      ctaButton: 'Avvia Processo di Design',
    },
    businessConsulting: {
      title: 'Consulenza Aziendale',
      metaDescription: 'Ottieni una guida esperta per ottimizzare le tue operazioni e accelerare la crescita aziendale attraverso metodologie collaudate.',
      intro: 'Ottieni una guida esperta per ottimizzare le tue operazioni e accelerare la crescita aziendale attraverso metodologie collaudate.',
      consultingAreas: 'Aree di Consulenza',
      consultingItems: [
        'Pianificazione Strategica',
        'Ottimizzazione delle Operazioni',
        'Analisi Finanziaria',
        'Strategia di Crescita',
      ],
      benefits: 'Benefici',
      benefitsItems: [
        'Efficienza Migliorata',
        'Riduzione dei Costi',
        'Crescita dei Ricavi',
        'Migliore Presa di Decisioni',
      ],
      ctaTitle: 'Pronto a Ottimizzare?',
      ctaText: 'Analizziamo la tua attivita e creiamo una roadmap per una crescita sostenibile.',
      ctaButton: 'Prenota Consulenza',
    },
    businessSoftware: {
      title: 'Soluzioni Software Aziendale',
      metaDescription: 'Trasforma le tue operazioni aziendali con soluzioni software accuratamente selezionate e implementate che semplificano i processi e aumentano l\'efficienza.',
      intro: 'Trasforma le tue operazioni aziendali con soluzioni software accuratamente selezionate e implementate che semplificano i processi e aumentano l\'efficienza.',
      ourApproach: 'Il Nostro Approccio',
      approachItems: [
        'Analisi dei Processi Aziendali',
        'Raccolta dei Requisiti Software',
        'Valutazione e Selezione di Soluzioni',
        'Implementazione e Integrazione',
      ],
      solutionAreas: 'Aree di Soluzione',
      solutionItems: [
        'Sistemi ERP',
        'Piattaforme CRM',
        'Strumenti di Gestione Progetti',
        'Sviluppo Software Personalizzato',
      ],
      ctaTitle: 'Pronto a Ottimizzare le Tue Operazioni?',
      ctaText: 'Identifichiamo le soluzioni software perfette per trasformare i tuoi processi aziendali.',
      ctaButton: 'Pianifica Consulenza',
    },
  },
  seo: {
    homeTitle: "Costruire l'Eccellenza Aziendale di Domani",
    homeDescription: "Impresstars orchestra operazioni aziendali ad alte prestazioni attraverso il nostro innovativo sistema Star Model. Dall'incorporazione alla strategia di crescita, siamo il tuo partner per l'eccellenza operativa.",
    portfolioTitle: 'Portfolio',
    portfolioDescription: 'Esplora la nostra collezione completa di progetti di successo e case study in varie industrie.',
    partnersTitle: 'Strumenti e Partner Consigliati',
    partnersDescription: 'Strumenti e piattaforme che Impresstars utilizza e consiglia per i clienti. Inizia con tecnologia di prima classe tramite i nostri link di referral.',
  },
  languageSwitcher: {
    label: 'Lingua',
  },
};
